<h1>{{'m2.sprint3.cockpit.card.funktionswert.title' | translate}}</h1>

<app-chart-dialog-funktionswert></app-chart-dialog-funktionswert>
<app-chart-dialog-lohnband></app-chart-dialog-lohnband>
